//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useContext, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

// === COMPONENTS ===
import { ExpressionContext } from 'pages/DocAnalytics/RuleView/components/ExpressionContext/ExpressionContext';

// === UTILS ===

//#endregion

//-----------------------------------------------------------------
export function SourceSelect( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id, is_predicate } = props;

  const _symbol_colors = {
    undefined: '',
    'FIELD'    : '#00FFFF',
    'DOR'      : '#FF00FF',
    'CONSTANT' : '#B882ED',
    'OPERATOR' : '#00FF00',
  }

  const _source_items = [
    { label: 'Operator', value: 'OPERATOR' },
    { label: 'Field'   , value: 'FIELD'    },
    { label: 'DoR'     , value: 'DOR'      },
    { label: 'Constant', value: 'CONSTANT' },
    { label: 'Function', value: 'FUNCTION' },
  ]

  const { updateExpression, updatePredicate } = useContext( ExpressionContext );

  const [ source, setSource ] = useState( props.source );

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    select_source: {
      width: '10rem',
      gridColumn: 3,
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
      // backgroundColor: _symbol_colors[source] + getHexAlpha(30),
    },
  }

  const SELECT_SOURCE = {
    sx: _styles.select_source,
    labelId: 'source-label',
    id     : 'source-select',
    label  : 'Source',
    value  : source,
    size   : 'small',
    name   : 'da_predicate_source_select',
    onChange: onChange_Source,
    children: _source_items.map( item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)
  };
    
  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange_Source( event ) {
    //-----------------------------------------------------------------
    setSource( event.target.value );
    if( props.onChange ) props.onChange( event.target.value );
    const update = is_predicate ? updatePredicate : updateExpression;
    update( id , { source: event.target.value } )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <FormControl>
        <InputLabel id="source-label">Source</InputLabel>
        <Select   { ...SELECT_SOURCE } />
      </FormControl>
    );
  }

  //#endregion

  return display();
}
